export default __webpack_public_path__ + "static/media/flipkart.6b8b5b15.png";